const META_HOTEL_USER_SOURCE = 'meta hotel';
// NOTE: mirrors CustomerOriginQueryParamValue.MetaHotel, which cannot be
// imported here because @libs/feature-toggle already depends on this library.
const META_HOTEL_CUSTOMER_ORIGIN = 'meta-hotel';

// The source is read from the URL and never from the affiliate cookie, whose
// long expiration would keep matching stale visits.
export function isMetaHotelUser(): boolean {
  const urlParams = new URL(window.location.href).searchParams;
  const userSource = urlParams.get('utm_medium');
  const customerOrigin = urlParams.get('customer-origin')?.trim();

  return (
    userSource?.toLowerCase() === META_HOTEL_USER_SOURCE ||
    customerOrigin === META_HOTEL_CUSTOMER_ORIGIN
  );
}
